module.exports = __webpack_public_path__ + "files/SPIADI2024 - Journée Nationale - Appel à communication.3c8cd9d36651f4cc1ee80a0bdae06e0c.pdf";